import * as Actions from "./constants";
const initialState = {
  deleteSuccess: false,
  //updateSuccess: false,
};

export default function subscriptionAdminReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.CREATE_SUBSCRIPTION:
      return {
        ...state,
      };
    case Actions.CREATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscription: action.payload,
      };
    case Actions.CREATE_SUBSCRIPTION_ERROR:
      return {
        ...state,
        createError: action.error,
      };
    case Actions.GET_ALL_SUBSCRIPTION:
      return {
        ...state,
      };
    case Actions.GET_ALL_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscriptionList: action.payload,
      };
    case Actions.GET_ALL_SUBSCRIPTION_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case Actions.GET_MASTERS:
      return {
        ...state,
      };
    case Actions.GET_MASTERS_SUCCESS:
      return {
        ...state,
        companies: action.company,
        features: action.feature,
        subFeatures: action.subFeature,
      };
    case Actions.GET_MASTERS_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case Actions.DELETE_PLAN:
      return {
        ...state,
      };
    case Actions.DELETE_PLAN_SUCCESS:
      return {
        ...state,
        deleteSuccess: true,
      };
    case Actions.DELETE_PLAN_ERROR:
      return {
        ...state,
        deletePlanError: action.error,
      };
    case Actions.EDIT_PLAN:
      return {
        ...state,
      };
    case Actions.EDIT_PLAN_SUCCESS:
      return {
        ...state,
        planDetails: action.payload,
      };
    case Actions.EDIT_PLAN_ERROR:
      return {
        ...state,
      };
    case Actions.UPDATE_PLAN:
      return {
        ...state,
        updateSuccess: false,
      };
    case Actions.UPDATE_PLAN_SUCCESS:
      return {
        ...state,
        updateSuccess: true,
      };
    case Actions.UPDATE_PLAN_ERROR:
      return {
        ...state,
        updateSuccess: false,
        updatePlanError: action.error,
      };
    case Actions.UPDATE_VISIBILITY_STATUS:
      return {
        ...state,
        updateStatusSuccess: false,
      };
    case Actions.UPDATE_VISIBILITY_STATUS_SUCCESS:
      return {
        ...state,
        updateStatusSuccess: true,
      };
    case Actions.UPDATE_VISIBILITY_STATUS_ERROR:
      return {
        ...state,
        updateStatusSuccess: false,
        updateStatusError: action.error,
      };
    default:
      return state;
  }
}
